import type { CalculationSection } from '@features/glossary/domain/calculations';
import { SHARED_CALCULATIONS } from '@features/glossary/domain/shared-calculations';
import { GLOSSARY } from './glossary';

export const CALCULATIONS: Readonly<Record<'salesLift', CalculationSection>> = {
  salesLift: {
    label: 'Sales Lift',
    items: {
      transactionSize: {
        label: 'Transaction Size',
        definition: GLOSSARY.transactionSize.definition,
        calculation:
          'Transaction Size = (Total Sales of the Exposed) / (Total Number of Transactions of Exposed)',
        calculationType: 'simple',
      },
      incrementalSales: {
        label: 'Incremental Sales',
        definition: GLOSSARY.incrementalSales.definition,
        calculationType: 'multi',
        calculationByType: {
          inStore:
            'Incremental Sales (In-Store) = (Exposed Sales In-Store - Control In-Store Sales) / PMR * Projection Factor',
          online:
            'Incremental Sales (Online) = (Exposed Sales Online - Control Sales Online) / PMR * Projection Factor',
        },
        additionalCalculations: [
          'Sales Rate = Total Projected Sales / Unique users (exposed)',
        ],
      },
      incrementalSalesLift: {
        label: 'Incremental Sales Lift',
        definition: GLOSSARY.incrementalSalesLift.definition,
        calculation:
          'Sales Lift = (Exposed Sales - Control Sales) / Control Sales',
        calculationType: 'simple',
      },
      returnOnAdSpend: SHARED_CALCULATIONS.returnOnAdSpend,
      incrementalReturnOnAdSpend:
        SHARED_CALCULATIONS.incrementalReturnOnAdSpend,
      transactionRate: {
        label: 'Transaction Rate',
        definition: GLOSSARY.transactionRate.definition,
        calculation:
          'Transaction Rate = (Count of Post Exposed Transactions) / (Count of Matched Exposed Users >= 1 Purchase)',
        calculationType: 'simple',
      },
      penetration: {
        label: 'Penetration',
        definition: GLOSSARY.penetration.definition,
        calculation:
          'Penetration = Sales / (Transaction Size * Transaction Rate * Exposed Users)',
        calculationType: 'simple',
      },
      salesRate: {
        label: 'Sales Rate',
        definition: GLOSSARY.salesRate.definition,
        calculation:
          'Sales Rate = Total Projected Sales / Unique users (exposed)',
        calculationType: 'simple',
      },
      totalProjectedSales: {
        label: 'Total Projected Sales',
        definition: GLOSSARY.totalProjectedSales.definition,
        calculationType: 'multi',
        calculationByType: {
          inStore:
            'Total Sales (In-Store) = Exposed Sales In-Store * Projection Factor / PMR',
          online:
            'Total Sales (Online) = Exposed Sales Online * Projection Factor / PMR',
        },
        additionalCalculations: [
          'Total Sales (Combined) = Total Sales (In-Store) + Total Sales (Online)',
        ],
      },
      contributionMetricLift: {
        label: 'Contribution Metric Lift',
        definition:
          'To determine the contribution to lift of penetration, transaction rate, and transaction size we utilize Shapley values to determine the marginal contribution of these factors to the lift estimate.',
        calculation:
          'Shapley values determine the marginal contribution of penetration, transaction rate, and transaction size to the lift estimate.',
        calculationType: 'simple',
      },
    },
  },
};
